import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, JhiLanguageService } from 'ng-jhipster';

import { PaymentItem } from './payment-item.model';
import { PaymentItemPopupService } from './payment-item-popup.service';
import { PaymentItemService } from './payment-item.service';
import { School, SchoolService } from '../school';
import { PaymentService, PaymentTypeaheadService } from '../payment';
import { Student, StudentService, StudentTypeaheadService } from '../student';
import { Enrollment, EnrollmentService } from '../enrollment';
import { Card, CardService } from '../card';
import { Reservation, ReservationService, ReservationStatus } from '../reservation';
import { studentGlobalLocations } from '../../shared/constants/student.locations.constants';
import { AbstractDialogComponent } from '../abstract-dialog-component/abstract-dialog.component';
import { Principal, CRUD_ACTIONS } from '../../shared';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { EventReservation } from '../event-reservation/event-reservation.model';
import { EventReservationService } from '../event-reservation/event-reservation.service';

@Component({
    selector: 'jhi-payment-item-dialog',
    templateUrl: './payment-item-dialog.component.html'
})
export class PaymentItemDialogComponent extends AbstractDialogComponent implements OnInit {

    currentAccount: any;
    paymentItem: PaymentItem;

    authorities: any[];
    isSaving: boolean;

    students: Student[];

    cards: Card[];
    reservations: Reservation[];
    eventReservations: EventReservation[];
    beneficiarySearch = this.studentTypeaheadService.search;
    beneficiaryResultFormatter = this.studentTypeaheadService.resultFormatter;

    private subscription: any;

    constructor(
        public activeModal: NgbActiveModal,
        private jhiLanguageService: JhiLanguageService,
        alertService: AlertService,
        private paymentItemService: PaymentItemService,
        schoolService: SchoolService,
        private paymentService: PaymentService,
        private studentService: StudentService,
        private cardService: CardService,
        private reservationService: ReservationService,
        private eventReservationService: EventReservationService,
        private eventManager: EventManager,
        principal: Principal,
        private studentTypeaheadService: StudentTypeaheadService,
        private route: ActivatedRoute
    ) {
        super(schoolService, alertService, principal);
    }

    ngOnInit() {
        this.principal.identity()
        .then((account) => {
            this.currentAccount = account;
        })
        .then(() => {
            if (this.paymentItem && this.paymentItem.beneficiary) {
                this.loadProducts(this.paymentItem.beneficiary);
            }
        });
        this.loadSchools();
    }

    beneficiaryInputFormatter = (student: any) =>
        this.studentTypeaheadService.inputFormatter(student, () => {
            return this.paymentItem.beneficiary['user'];
        })

    clear() {
        this.activeModal.dismiss('cancel');
    }

    save(form: NgForm) {
        let isValidForm = true;
        if (!(this.paymentItem.payment instanceof Object)) {
            let paymentInput = form !== undefined ? form.controls['payment'] : null;
            if (paymentInput !== null) {
                paymentInput.reset();
            }
            isValidForm = false;
        }

        if (!(this.paymentItem.beneficiary instanceof Object)) {
            let beneficiaryInput = form !== undefined ? form.controls['beneficiary'] : null;
            if (beneficiaryInput !== null) {
                beneficiaryInput.reset();
            }
            isValidForm = false;
        }

        if (isValidForm) {
            this.isSaving = true;
            if (this.paymentItem.id !== undefined) {
                this.paymentItemService.update(this.paymentItem)
                    .subscribe(
                        (res: PaymentItem) => {
                            return this.onSaveSuccess(res, CRUD_ACTIONS.UPDATE);
                        },
                        (res: HttpErrorResponse) => {
                            return this.onSaveError(res);
                        }
                    );
            } else {
                this.paymentItemService.create(this.paymentItem)
                    .subscribe(
                        (res: PaymentItem) => {
                            return this.onSaveSuccess(res, CRUD_ACTIONS.CREATE);
                        },
                        (res: HttpErrorResponse) => {
                            return this.onSaveError(res);
                        }
                    );
            }
        }
    }

    onBeneficiaryChange(selectedBeneficiary: Student, form: NgForm) {
        if (this.paymentItem.beneficiary instanceof Object) {
            this.loadProducts(selectedBeneficiary);
            form.controls['card'].enable();
            form.controls['reservation'].enable();
            form.controls['eventReservation'].enable();
        } else {
            this.paymentItem.card = null;
            this.paymentItem.reservation = null;
            form.controls['card'].disable();
            form.controls['reservation'].disable();
            form.controls['eventReservation'].disable();
        }
    }

    onCardChange(selectedCard: Card) {
        if (this.paymentItem) {
            this.paymentItem.reservation = null;
            this.paymentItem.eventReservation = null;
        }
    }

    onReservationChange(selectedReservation: Reservation) {
        if (this.paymentItem) {
            this.paymentItem.card = null;
            this.paymentItem.eventReservation = null;
        }
    }

    onEventReservationChange(selectedEventReservation: EventReservation) {
        if (this.paymentItem) {
            this.paymentItem.card = null;
            this.paymentItem.reservation = null;
        }
    }

    loadProducts(student?: Student) {
        // we get the last 20 items to not overload the server
        let maxResults = 20;
        if (student) {
            this.cardService
                .search({
                    query: 'student.id:' + student.id,
                    sort: ['validSince', 'desc'],
                    size: maxResults
                })
                .subscribe(
                    (res: HttpResponse<Card[]>) => {
                        this.cards = this.getNotPayedProducts(this.paymentItem.card, res.body);
                    },
                    (res: HttpErrorResponse) => {
                        this.onError(res);
                    }
                );
            this.reservationService
                .search({
                    query: 'student.id:' + student.id + ' AND ' +
                    '!(status:' + ReservationStatus.CANCELLED + ')' + ' AND ' + '!(status:' + ReservationStatus.LESSON_CANCELLED + ')',
                    size: maxResults,
                    sort: ['lesson.begining', 'desc']
                })
                .subscribe(
                    (res: HttpResponse<Reservation[]>) => {
                        this.reservations = res.body;
                    },
                    (res: HttpErrorResponse) => {
                        this.onError(res);
                    }
                );

            this.eventReservationService
                .search({
                    query: 'student.id:' + student.id,
                    size: maxResults,
                    sort: ['event.begining', 'desc']
                })
                .subscribe(
                    (res: HttpResponse<EventReservation[]>) => {
                        this.eventReservations = res.body;
                    },
                    (res: HttpErrorResponse) => {
                        this.onError(res);
                    }
                );
        }
    }

    trackSchoolById(index: number, item: School) {
        return item.id;
    }

    trackStudentById(index: number, item: Student) {
        return item.id;
    }

    trackEnrollmentById(index: number, item: Enrollment) {
        return item.id;
    }

    trackCardById(index: number, item: Card) {
        return item.id;
    }

    trackReservationById(index: number, item: Reservation) {
        return item.id;
    }

    getPaymentPayer() {
        return this.paymentItem.payment.payer['user'].firstName + ' '
            + this.paymentItem.payment.payer['user'].lastName;
    }

    private onSaveSuccess(result: PaymentItem, action: string) {
        this.eventManager.broadcast({
            name: 'paymentItemListModification',
            content: {
                action: action,
                content: result
            }
        });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError(error) {
        this.isSaving = false;
        this.onError(error);
    }

    canChooseProduct() {
        return this.paymentItem.id === undefined;
    }

    canChooseBeneficiary() {
        return this.paymentItem.id === undefined;
    }

    private getNotPayedProducts(productRelatedToPaymentItem: any, allProducts: any[]) {
        let notPayedProducts = [];
        let payedProduct: number = productRelatedToPaymentItem ? productRelatedToPaymentItem.id : null;
        if (payedProduct) {
            notPayedProducts.push(productRelatedToPaymentItem);
        }

        allProducts.forEach(product => {
            if (product.id !== payedProduct
                && product.totalPaid < product.price) {
                    notPayedProducts.push(product);
            }
        });

        return notPayedProducts;
    }

}

@Component({
    selector: 'jhi-payment-item-popup',
    template: ''
})
export class PaymentItemPopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private paymentItemPopupService: PaymentItemPopupService
    ) { }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            if (params['id']) {
            // Edit payment item
                this.modalRef = this.paymentItemPopupService
                    .open(PaymentItemDialogComponent as Component, params['id']);
            } else {
            // Create payment item
                this.modalRef = this.paymentItemPopupService
                    .openCreate(PaymentItemDialogComponent as Component, params['idPayment']);
            }
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/payment-item/payment-item-dialog.component.ts